module.exports = __webpack_public_path__ + "static/media/Female04.92f9d900.jpg";